import { useRecordPageView } from "src/hooks/recordEvent";

export const PageView = (): any => {
  useRecordPageView();
  return null;
};
